import axios from "axios";
import { useMutation } from "react-query";

const API_PATH = "exclusivelists";

export const useSearchProducts = (props: {
  controller: AbortController;
  setController: React.Dispatch<React.SetStateAction<AbortController>>;
}) =>
  useMutation((keywords: string) => {
    props.controller.abort();
    const newController = new AbortController();
    props.setController(newController);
    return axios
      .get(`${API_PATH}/SearchProducts`, {
        params: { keywords },
        signal: newController.signal,
      })
      .then((res) => res.data?.data as any[])
      .catch((reason) => Promise.reject(reason.response));
  });

export const useCreateExclusiveList = () =>
  useMutation((name: string) =>
    axios
      .post(`${API_PATH}/create`, { name })
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useUpdateExclusiveListName = () =>
  useMutation((data: { id: string; name: string }) =>
    axios
      .post(`${API_PATH}/updatename`, data)
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useDeleteExclusiveList = () =>
  useMutation((id: string) =>
    axios
      .post(`${API_PATH}/delete`, { id })
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useAddProduct = () =>
  useMutation((data: { exclusiveListId: string; productId: string }) =>
    axios
      .post(`${API_PATH}/addproduct`, data)
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useRemoveProduct = () =>
  useMutation((exclusiveListProductId: string) =>
    axios
      .post(`${API_PATH}/removeproduct`, { id: exclusiveListProductId })
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useGetAssignedCustomers = () =>
  useMutation((exclusiveListId: string) =>
    axios
      .get(`${API_PATH}/GetAssignedCustomers`, { params: { exclusiveListId } })
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useSearchCustomers = () =>
  useMutation((params: { keywords: string; exclusiveListId: string }) =>
    axios
      .get(`${API_PATH}/SearchCustomers`, { params })
      .then((res) => res.data?.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useAssignCustomer = () =>
  useMutation((data: { exclusiveListId: string; customerAccountId: string }) =>
    axios
      .post(`${API_PATH}/AssignCustomer`, data)
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useToggleCustomerAssignment = () =>
  useMutation((data: { assignmentId: string; isActive: boolean }) =>
    axios
      .post(`${API_PATH}/ToggleCustomerAssignment`, data)
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );

export const useRemoveCustomerAssignment = () =>
  useMutation((assignmentId: string) =>
    axios
      .post(`${API_PATH}/RemoveCustomerAssignment`, { assignmentId })
      .then((res) => res.data)
      .catch((reason) => Promise.reject(reason.response))
  );
